import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const TIMEPOINT_ENDPOINT_BEHAVIOUR = {
  INCLUSIVE: 'INCLUSIVE',
  EXCLUSIVE: 'EXCLUSIVE'
};
export const PROPERTY_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  ENUMERATION: 'enumeration',
  ALL_TYPES: 'alltypes',
  TIMEPOINT: 'timepoint',
  DATETIME_ROLLING: 'datetime-rolling',
  RANGED_TIME: 'rangedtime',
  MULTISTRING: 'multistring'
};
export const LIST_OPERATORS = {
  IS_KNOWN: 'IS_KNOWN',
  IS_UNKNOWN: 'IS_UNKNOWN',
  IS_ANY_OF: 'IS_ANY_OF',
  IS_NONE_OF: 'IS_NONE_OF',
  IS_EXACTLY: 'IS_EXACTLY',
  IS_NOT_EXACTLY: 'IS_NOT_EXACTLY',
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
  IS_EQUAL_TO: 'IS_EQUAL_TO',
  IS_NOT_EQUAL_TO: 'IS_NOT_EQUAL_TO',
  IS_AFTER: 'IS_AFTER',
  IS_BEFORE: 'IS_BEFORE',
  IS_BETWEEN: 'IS_BETWEEN',
  IS_NOT_BETWEEN: 'IS_NOT_BETWEEN',
  IS_MORE_THAN_X_DAYS_AGO: 'IS_MORE_THAN_X_DAYS_AGO',
  IS_MORE_THAN_X_DAYS_FROM_NOW: 'IS_MORE_THAN_X_DAYS_FROM_NOW',
  IS_LESS_THAN_X_DAYS_AGO: 'IS_LESS_THAN_X_DAYS_AGO',
  IS_LESS_THAN_X_DAYS_FROM_NOW: 'IS_LESS_THAN_X_DAYS_FROM_NOW',
  IS_LESS_THAN: 'IS_LESS_THAN',
  IS_LESS_THAN_OR_EQUAL_TO: 'IS_LESS_THAN_OR_EQUAL_TO',
  IS_GREATER_THAN: 'IS_GREATER_THAN',
  IS_GREATER_THAN_OR_EQUAL_TO: 'IS_GREATER_THAN_OR_EQUAL_TO',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH'
};
const mapOperatorsToPropertyType = (operators, propertyType) => {
  return operators.reduce((acc, operator) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return Object.assign({}, acc, {
      [operator]: propertyType
    });
  }, {});
};
export const COMMON_OPERATORS = mapOperatorsToPropertyType([LIST_OPERATORS.IS_KNOWN, LIST_OPERATORS.IS_UNKNOWN], PROPERTY_TYPES.ALL_TYPES);
export const RADIO_AND_DROPDOWN_OPERATORS = Object.assign({}, mapOperatorsToPropertyType([LIST_OPERATORS.IS_ANY_OF, LIST_OPERATORS.IS_NONE_OF], PROPERTY_TYPES.ENUMERATION), COMMON_OPERATORS);
export const ENUMERATION_OPERATORS = Object.assign({}, mapOperatorsToPropertyType([LIST_OPERATORS.IS_ANY_OF, LIST_OPERATORS.IS_NONE_OF, LIST_OPERATORS.IS_EXACTLY, LIST_OPERATORS.IS_NOT_EXACTLY, LIST_OPERATORS.CONTAINS_ALL, LIST_OPERATORS.DOES_NOT_CONTAIN_ALL], PROPERTY_TYPES.ENUMERATION), COMMON_OPERATORS);
export const DATE_OPERATORS = Object.assign({}, mapOperatorsToPropertyType([LIST_OPERATORS.IS_AFTER, LIST_OPERATORS.IS_BEFORE], PROPERTY_TYPES.TIMEPOINT), mapOperatorsToPropertyType([LIST_OPERATORS.IS_BETWEEN, LIST_OPERATORS.IS_NOT_BETWEEN], PROPERTY_TYPES.RANGED_TIME), COMMON_OPERATORS);
export const NUMBER_OPERATORS = Object.assign({}, mapOperatorsToPropertyType([LIST_OPERATORS.IS_EQUAL_TO, LIST_OPERATORS.IS_NOT_EQUAL_TO, LIST_OPERATORS.IS_GREATER_THAN, LIST_OPERATORS.IS_GREATER_THAN_OR_EQUAL_TO, LIST_OPERATORS.IS_LESS_THAN, LIST_OPERATORS.IS_LESS_THAN_OR_EQUAL_TO], PROPERTY_TYPES.NUMBER), COMMON_OPERATORS);
export const STRING_OPERATORS = Object.assign({}, mapOperatorsToPropertyType([LIST_OPERATORS.IS_EQUAL_TO, LIST_OPERATORS.IS_NOT_EQUAL_TO, LIST_OPERATORS.CONTAINS, LIST_OPERATORS.DOES_NOT_CONTAIN, LIST_OPERATORS.STARTS_WITH, LIST_OPERATORS.ENDS_WITH], PROPERTY_TYPES.MULTISTRING), COMMON_OPERATORS);
export const LIST_OPERATORS_BY_FIELD_TYPE = {
  [FieldTypes.TEXT]: STRING_OPERATORS,
  [FieldTypes.TEXTAREA]: STRING_OPERATORS,
  [FieldTypes.RADIO]: RADIO_AND_DROPDOWN_OPERATORS,
  [FieldTypes.SELECT]: RADIO_AND_DROPDOWN_OPERATORS,
  [FieldTypes.CHECKBOX]: ENUMERATION_OPERATORS,
  [FieldTypes.SINGLE_CHECKBOX]: RADIO_AND_DROPDOWN_OPERATORS,
  [FieldTypes.DATE]: DATE_OPERATORS,
  [FieldTypes.NUMBER]: NUMBER_OPERATORS,
  [FieldTypes.PHONE_NUMBER]: STRING_OPERATORS,
  [FieldTypes.FILE]: COMMON_OPERATORS,
  [FieldTypes.PAYMENT_RADIO]: RADIO_AND_DROPDOWN_OPERATORS,
  [FieldTypes.SUBMIT]: STRING_OPERATORS,
  [FieldTypes.PHONE]: STRING_OPERATORS,
  [FieldTypes.MOBILE_PHONE]: STRING_OPERATORS
};